import styled from "styled-components"

export const Wrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .main-part{
        width: 100%;
        height: auto;
        margin-top: 75px;
    }
`